class LoginDrawer extends HTMLElement {
  constructor() {
    super();

    // Close events
    this.addEventListener("keyup", evt => evt.code === "Escape" && this.close());
    this.querySelector("#LoginDrawer-Overlay")
        ?.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", evt => {
      if (evt.target === this) this.close();
    });
    window.addEventListener('cart-opened', this.close.bind(this));
    window.addEventListener('care-services-drawer-opened', this.close.bind(this));

    this.setTriggerAccessibility();
    this.setupViewSwitching();

    const closeButton = this.querySelector('#header__login-drawer-close');
    closeButton?.addEventListener('click', this.close.bind(this));

    //this.setupLoginForm();
  }

  async login(formData) {
    return fetch('/account/login', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    }).then(async response => ({
      response,
      html: await response.text()
    }));
  }

  setupLoginForm() {
    const loginForm = this.querySelector('#drawer-login-form');
    if (!loginForm) return;

    const handleLogin = async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const formData = new FormData(loginForm);
      const submitButton = loginForm.querySelector('.button--login');
      submitButton && (submitButton.disabled = true);

      try {
        const result = await this.login(formData);

        // Parse HTML to check errors
        const parser = new DOMParser();
        const doc = parser.parseFromString(result.html, 'text/html');

        // 1️⃣ SUCCESS → redirect if Shopify redirected
        if (result.response.redirected || result.response.url.includes('/account')) {
          window.location.href = result.response.url;
          return;
        }

        // 2️⃣ CAPTCHA → full-page login
        const captchaPage = doc.querySelector('form#customer_login h1')?.textContent?.includes('CAPTCHA');
        if (captchaPage || result.response.url.includes('/account/login')) {
          window.location.href = '/account/login';
          return;
        }

        // 3️⃣ WRONG CREDENTIALS → show error in drawer
        const errors = doc.querySelector('.errors, .form__message, [role="alert"]');
        let errorBox = loginForm.querySelector('.form__message');
        if (!errorBox) {
          errorBox = document.createElement('div');
          errorBox.className = 'form__message form__message--error';
          loginForm.prepend(errorBox);
        }

        errorBox.innerHTML = errors ? errors.innerHTML : 'Incorrect email or password.';

      } catch (err) {
        console.error('Login failed:', err);
        let errorBox = loginForm.querySelector('.form__message');
        if (!errorBox) {
          errorBox = document.createElement('div');
          errorBox.className = 'form__message form__message--error';
          loginForm.prepend(errorBox);
        }
        errorBox.textContent = 'Something went wrong. Please try again.';
      } finally {
        submitButton && (submitButton.disabled = false);
      }
    };

    loginForm.addEventListener('submit', handleLogin);
    loginForm.querySelector('.button--login')?.addEventListener('click', handleLogin);
  }

  setTriggerAccessibility() {
    document.querySelectorAll('.login-drawer-trigger').forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', e => {
        e.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', e => {
        if (e.code === 'Space') {
          e.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  setupViewSwitching() {
    this.querySelectorAll('[data-view-switch]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        this.switchView(link.getAttribute('data-view-switch'));
      });
    });
  }

  switchView(view) {
    this.querySelectorAll('.login-drawer__view')
        .forEach(v => v.classList.remove('active'));
    const target = this.querySelector(`[data-view="${view}"]`);
    target?.classList.add('active');

    const firstInput = target?.querySelector('input');
    firstInput && setTimeout(() => firstInput.focus(), 100);
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    this.switchView('login');
    const drawerContainer = this.querySelector('.login-content');
    if (drawerContainer) {
      drawerContainer.scrollTop = 0;
    }

    setTimeout(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
    window.dispatchEvent(new Event('login-drawer-opened'));
  }

  close() {
    // Add closing class for animation - matching global drawer pattern
    this.classList.add('closing');
    this.classList.remove('active');

    // Wait for animation to complete before cleanup (matches --animation-duration-4: 0.4s = 400ms)
    setTimeout(() => {
      this.classList.remove('closing', 'animate');
    }, 400);

    // Re-enable body scroll
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('login-drawer', LoginDrawer);
